<template>
    <div class="price-range">
        <money v-model="start" class="form-control start"></money> - <money v-model="end" class="form-control end"></money>
    </div>
</template>

<script>
    let interval;

    export default
    {
        model: {
            prop: 'priceRange',
            event: 'update',
        },
        props: {
            priceRange: {
                default: null,
                required: true,
            },
            interval: {
                type: Number,
            }
        },
        data()
        {
            return {
                start: this.priceRange.startPrice || 0,
                end: this.priceRange.endPrice || 0,
            };
        },
        methods:
        {
            update()
            {
                let result = {startPrice: this.start, endPrice: this.end};

                if (this.interval)
                {
                    const v = this;
                    clearInterval(interval);

                    interval = setTimeout(() => {
                        v.$emit('update', result);
                    }, this.interval);

                    return ;
                }

                this.$emit('update', result);
            }
        },
        watch:
        {
            'start' (value)
            {
                this.update();
            },
            'end' (value)
            {
                this.update();
            }
        }
    }
</script>

<style lang="scss">
    .price-range
    {
        .start, .end {
            width:120px;
        }
    }
</style>


// WEBPACK FOOTER //
// PriceRange.vue?79662d76